import React, { useState } from 'react';
import { Waypoint } from 'react-waypoint';
import LoadingIndicator from './LoadingIndicator';

/**
 * An abstract component that tracks when the nearest scroll parent is
 * approaching the bottom of the scroll area, and fires a callback to load more items.
 */
function InfiniteList({
  loadMore,
  hasMore,
  bottomOffset = -500,
  loadingIndicator = React.createElement(LoadingIndicator, null),
  children
}) {
  const [loading, setLoading] = useState(false);

  const handleEnterWaypoint = () => {
    if (!hasMore()) {
      return;
    }

    setLoading(true);
    loadMore(error => {
      if (error) {
        return;
      }

      setLoading(false);
    });
  };

  return React.createElement(React.Fragment, null, children, loading ? loadingIndicator : React.createElement(Waypoint, {
    onEnter: handleEnterWaypoint,
    bottomOffset: bottomOffset
  }));
}

export default InfiniteList;